var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { getMultiLangText } from '../../../utils/text';
var CardAction = (function (_super) {
    __extends(CardAction, _super);
    function CardAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardAction.prototype.getActionItems = function (actionSize, data) {
        var size = parseInt(actionSize);
        var items = [];
        for (var i = 0; i < size; i++) {
            var code = data["action" + (i + 1) + "Code"];
            var txt = data["action" + (i + 1) + "Txt"];
            items.push({ code: code, txt: txt });
        }
        return items;
    };
    CardAction.prototype.render = function () {
        var _a = this.props, templateData = _a.templateData, langKey = _a.langKey, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
        var txt = templateData.txt, actionSize = templateData.actionSize;
        var items = this.getActionItems(actionSize, templateData);
        return (React.createElement("div", { className: "message-text-box" },
            React.createElement("div", { className: "lzd-message-text" }, getMultiLangText(txt, langKey)),
            React.createElement("div", { className: "lzd-message-actions" }, items.map(function (item, i) { return (React.createElement("div", { key: i, className: "action-item" },
                React.createElement("a", { className: "action-link", onClick: function () { return onClick(item); } }, getMultiLangText(item.txt, langKey)))); }))));
    };
    return CardAction;
}(React.Component));
export default CardAction;

//# sourceMappingURL=index.js.map
